module.exports = __webpack_public_path__ + "static/media/JxAsiaCalendarImg.9855acc7.png";